module.exports = __webpack_public_path__ + "img/syc.68f5b764.png";